<template>
<div>
    <div class="mt-2">
        <v-btn text @click="$router.push('/admin-centers')">
            <v-icon size="14px" color="grey darken-3" class="mr-3">fa-angle-left</v-icon>
            Back to Centers
        </v-btn>
    </div>

    <v-row v-if="loaded">
            <v-col cols="12" sm="7">
                <v-card>
                    <v-card-text>
        
                        <div class="title accent--text">Create new center</div>

                        <div class="d-flex align-center mt-3">
                            <v-icon small class="mr-3">fa-user</v-icon>
                            <v-select
                                v-model="model.director"
                                :items="directors"
                                item-text="name"
                                item-value="id"
                                append-icon="fa-angle-down primary--text"
                                label="Select director"
                                :disabled="directors.length==0">
                            </v-select>
                        </div>
                        <div class="mt-n4 ml-6 error--text" v-if="directors.length==0">
                            <v-icon size="14px" class="mr-1" color="error">fa-exclamation-triangle</v-icon>
                            There is no directors available for a new center.
                        </div>

                        <div class="d-flex align-end">
                            <v-icon small class="mr-3 mb-1">fa-tag</v-icon>
                            <v-text-field
                                v-model="model.name"
                                label="Name of the center"
                                maxlength="40"
                                @keydown.enter="validate"
                                hide-details>
                            </v-text-field>
                        </div>

                        <div class="text-end mt-10">
                            <v-btn 
                                depressed 
                                class="accent" 
                                @click="validate" 
                                :disabled="sending">Add center</v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <SendingLoader v-else/>
</div>
</template>

<script>
import _ from 'lodash'
import Centers from '@/firebase/centers'
import Users from '@/firebase/users'

export default {
    data: () => ({
        loaded: false,
        sending: false,
        model: {
            name: '',
            director: ''
        },
        directors: []
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Users.getDirectorWithoutCenter('director')
                    .then(response => {
                        if (response.status === true) {
                            this.formatItems(response.query);
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        formatItems(query) {
            query.forEach(dt => {
                let u = dt.data();
                u.id = dt.id;
                this.directors.push(u);
            });

            this.directors = _.orderBy(this.directors, 'name', 'asc');
        },
        validate() {
    		if (this.validateIsEmpty(this.model.director)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to select a director.'});
                return;
            }

            if (this.validateIsEmpty(this.model.name)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set a name.'});
                return;
            }

            this.add();
    	},
        add() {
            this.sending = true;
            let c = _.find(this.directors, dir => {return dir.id == this.model.director})
            this.model.director = {
                id: c.id,
                name: c.name
            }

            Centers.add(this.model)
                    .then(response => {
                        if (response === true) {
                            this.$router.push('/admin-centers');
                            this.$store.dispatch('setSnack', {kind:'success', text:'A center has added.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>